import { AdminApi } from 'stylemix-vue-admin'

export default class ImportEntitiesApi extends AdminApi {
  constructor(parameters) {
    super('import-entities', parameters)
  }

  startImport(id) {
    return this.submit('post', `import-entities/${id}/start-import`)
  }
}
